module.exports = __webpack_public_path__ + "img/recharge-tips.755e4e6c.png";